import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";
import { Footer } from "../../../components/Landing/Footer";
const Inversion = process.env.PUBLIC_URL + encodeURI("/assets/comunas/mapa y tabla balance 2025 movil.png");
import mapaCifras from "../../../assets/comunas/mapaCifras.png"

import beneficiariosImg from "../../../assets/landing/beneficiarios.png";
import guiaBeneficiarioImg from "../../../assets/landing/guiaBeneficiario.png";
// @ts-ignore
const guiaPdf = process.env.PUBLIC_URL + encodeURI("/assets/landing/Arteycultura (Convocatorias guia ajustada para creación de piezas 2026) pdf.pdf");

export const Beneficiarios = () => {

  return (
    <div style={{ overflowX: 'hidden', width: '100%' }}>
      <Header />
      <HeaderScc />
      <div className="container-fluid2">

        <div className="container mt-5 mb-5 pt-4">
          {/* Header Section */}
          <div className="row align-items-center mb-5">
            <div className="col-md-6 text-center">
              <img src={beneficiariosImg} alt="Beneficiarios" className="img-fluid" style={{ maxHeight: '400px' }} />
            </div>
            <div className="col-md-6 text-center mt-4 mt-md-0">
              <h1 className="fw-bold mb-4" style={{ color: '#333', fontSize: '3rem', fontFamily: 'Montserrat, sans-serif', fontWeight: 800 }}>
                Beneficiarios
              </h1>
              <h6 className="fw-bold mt-2 mb-2" style={{ fontSize: '1.4rem', color: '#000' }}>¡Felicitaciones!</h6>
              <p style={{ fontSize: '1.2rem', color: '#444', maxWidth: '450px', margin: '0 auto', lineHeight: '1.5' }}>
                Esta sección está dedicada a quienes, con su talento y compromiso, aportan al arte y la cultura de nuestra ciudad.
              </p>
            </div>
          </div>

          {/* Highlight Phrase */}
          <div className="row mb-5 mt-5">
            <div className="col-12 text-center">
              <h4 className="fw-bold" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '1.5rem', color: '#000' }}>
                ¡Gracias a las convocatorias lo hacemos posible!
              </h4>
            </div>
          </div>

          {/* Maps Section */}
          <div className="row justify-content-center mb-5 mt-5">
            <div className="col-12 text-center" id="mapContainer">
              <img src={mapaCifras} style={{ maxWidth: '100%' }} alt="Inversion comunas"></img>
            </div>
            <div className="col-12 text-center" id="mapContainerMovil">
              <img src={Inversion} style={{ maxWidth: '100%' }} alt="inversion comunas"></img>
            </div>
          </div>


        </div>
      </div>

      <div className="text-center w-100 mt-5">
        <h3 className="fw-bold mb-3 mx-auto" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '1.5rem', color: '#000' }}>
          Guía rápida para la creación de piezas gráficas
        </h3>
      </div>

      {/* Guia Banner */}
      <div style={{ backgroundColor: '#F0E2CD', position: 'relative', marginTop: '50px' }}>
        <div className="container">
          <div className="row">
            {/* Image Column */}
            <div className="col-12 col-md-6 text-center position-relative">
              {/* Desktop Image */}
              <img
                src={guiaBeneficiarioImg}
                alt="Guia Beneficiario"
                className="d-none d-md-inline-block"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '100%',
                  maxWidth: '450px',
                  height: 'auto',
                  zIndex: 1
                }}
              />

              {/* Mobile Image */}
              <img
                src={guiaBeneficiarioImg}
                alt="Guia Beneficiario"
                className="img-fluid d-md-none"
                style={{ maxWidth: '85%', zIndex: 1, position: 'relative', marginTop: '-50px', marginBottom: '20px' }}
              />
            </div>

            {/* Text Column */}
            <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center py-5 text-center" style={{ zIndex: 2, minHeight: '350px' }}>
              <p className="fw-bold mb-4" style={{ fontSize: '1rem', color: '#000', maxWidth: '350px', lineHeight: '1.4' }}>
                Aquí encontrarás consejos prácticos para que tus diseños y piezas comunicacionales salgan correctamente, con las indicaciones de uso del logo Alcaldía.
              </p>
              <div>
                <a
                  href={guiaPdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn px-4 py-2"
                  style={{ backgroundColor: '#E08E66', color: 'white', borderRadius: '25px', fontSize: '1rem', fontWeight: 600 }}
                >
                  Ver guía
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-5 mb-5 pt-5 pb-5">
        <p className="mb-0" style={{ color: '#333', fontSize: '1rem', lineHeight: '1.5' }}>
          ¡Únete a nuestra comunidad cultural!<br />
          Suscríbete y mantente al día.
        </p>
        <div className="mt-4">
          <a
            href="/estimuloscultura/login"
            className="btn px-4 py-2 shadow-sm"
            style={{ backgroundColor: '#F0A87A', color: '#333', borderRadius: '25px', fontSize: '1rem', fontWeight: 600, border: 'none' }}
          >
            Suscribirme
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

